export function resolveCardProductTagIds(mainTab: any, finalFilter: any, team?: any): string[] {
  const fromFinal = finalFilter?.tagIds;
  if (Array.isArray(fromFinal) && fromFinal.length > 0) return fromFinal;
  const fromTabFilter = mainTab?.filter?.tagIds;
  if (Array.isArray(fromTabFilter) && fromTabFilter.length > 0) return fromTabFilter;
  const fromRoot = mainTab?.tagIds;
  if (Array.isArray(fromRoot) && fromRoot.length > 0) return fromRoot;

  if (mainTab?.entityType === 'content_type_for_display' && team) {
    const shopNavTab = team.tabs?.find((t: { path?: string }) => t?.path === 'shop');
    const fromShopFilter = shopNavTab?.filter?.tagIds;
    if (Array.isArray(fromShopFilter) && fromShopFilter.length > 0) return fromShopFilter;
    const fromShopRoot = shopNavTab?.tagIds;
    if (Array.isArray(fromShopRoot) && fromShopRoot.length > 0) return fromShopRoot;
    const mainRow = team.shopTabs?.find((row: { isMain?: boolean }) => row?.isMain) ?? team.shopTabs?.[0];
    const fromShopTabsRow = mainRow?.filter?.tagIds;
    if (Array.isArray(fromShopTabsRow) && fromShopTabsRow.length > 0) return fromShopTabsRow;
  }

  return [];
}
export function resolveCardProductTagIds(mainTab: any, finalFilter: any, team?: any): string[] {
  const fromFinal = finalFilter?.tagIds;
  if (Array.isArray(fromFinal) && fromFinal.length > 0) return fromFinal;
  const fromTabFilter = mainTab?.filter?.tagIds;
  if (Array.isArray(fromTabFilter) && fromTabFilter.length > 0) return fromTabFilter;
  const fromRoot = mainTab?.tagIds;
  if (Array.isArray(fromRoot) && fromRoot.length > 0) return fromRoot;

  if (mainTab?.entityType === 'content_type_for_display' && team) {
    const shopNavTab = team.tabs?.find((t: { path?: string }) => t?.path === 'shop');
    const fromShopFilter = shopNavTab?.filter?.tagIds;
    if (Array.isArray(fromShopFilter) && fromShopFilter.length > 0) return fromShopFilter;
    const fromShopRoot = shopNavTab?.tagIds;
    if (Array.isArray(fromShopRoot) && fromShopRoot.length > 0) return fromShopRoot;
    const mainRow = team.shopTabs?.find((row: { isMain?: boolean }) => row?.isMain) ?? team.shopTabs?.[0];
    const fromShopTabsRow = mainRow?.filter?.tagIds;
    if (Array.isArray(fromShopTabsRow) && fromShopTabsRow.length > 0) return fromShopTabsRow;
  }

  return [];
}
